import { useEffect, useState } from "react";
import Nav from "../components/Nav";
import LocationHeader from "../components/main/LocationHeader";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet";
import ScrollNavbar from "../components/ScrollNavbar";
import NumberIncrement from "../components/NumberIncrement";
import ExploreGroomingService from "../components/ExploreGroomingService";
import LocationComponent from "../components/main/LocationComponent";
import MeetExpertsComponent from "../components/main/MeetExpertsComponent";
import HowFt from "../components/HowFt";
import LocationFaqComponent from "../components/main/LocationFaqComponent";
import NavTop from "../components/NavTop";
import OurLocation from "../components/OurLocation";
import PopupOffer from "../components/PopupOffer";
import LocationContentFaridabad from "../components/main/LocationContentFaridabad";
import GroomingFormComponent from "../components/form/GroomingFormComponent";
import LocationGroomingPackageComponent from "../components/LocationGroomingPackageComponent";

const FaridabadPage = () => {

  const [openForm, setOpenForm] = useState(false);

  const [offerPopup, setOfferPopup] = useState(false);

      const [petGroom, setPetGroom] = useState("Dog")
  

  useEffect( () => {

    const timer = setTimeout( () => {
      setOfferPopup(true)
    }, 15000)

    return () => clearInterval(timer)

  },[])
  
  

  const headerData = {
    heading: "Luxury At-Home Pet Grooming in Faridabad",
    text: "Same Day Booking - Smart Choice for Faridabad Pet Parents.",
  };

  const faqData = {
    heading: "",
    data: [

        {
          question: "Do you serve apartments in high-rises like those in Sector 75-89?",
          text: ["✅ Absolutely! We're experts at navigating Faridabad's high-rises. Just ensure:",
            "✔ Parking space for our mobile van",
            "✔ Elevator access (or we'll carry equipment upstairs!)",
            "✔ 2x2 feet balcony/utility area for grooming",
          ],
          points: [],
        },
        {
          question: "My Persian cat gets mats after walks near Badkhal Lake. Can you help?",
          text: [

            "✅ We specialize in 'Painless De-Matting' for Faridabad's humid climate:",
            "✔ Detangling sprays (no pulling)",
            "✔ Sanitary trims for hygiene",
            "✔ Lion cuts for severe cases (with cute styling!)",

            
          ],
          points: [],
        },
        {
          question: "Can you handle my aggressive Rottweiler?",
          text: [

"✅ Our Faridabad groomers are:",
"✔ Muzzle-trained (but use treats first!)",
"✔ Experienced with guard breeds (we service farmhouses too)",
"✔ Patient with trauma cases (street rescues welcome)",
            
          ],
          points: [],
        },
        {
          question: "Monsoon ticks are terrible near the Aravalli hills. Any solutions?",
          text: [
'✅ Our "Monsoon Defense Package" (₹200 extra):',
'Neem & aloe vera bath',
'Tick comb-out with magnifying lamp',
'Preventive spray (lasts 2 weeks)',

          ],
          points: [],
        },
        {
          question: "My society doesn't allow pets. Can we groom elsewhere?",
          text: [

"💡 Pro Workarounds:",
"✔ Society parking lot (we bring pop-up tents)",
"✔ Nearby parks (morning slots only)",
"✔ Your office cabin (after hours)",

            
          ],
          points: [],
        },
        
       {
          question: "How do I book a grooming session in Faridabad?",
          text: [""],
          points: [

'Call/WhatsApp: 96581 89189 (mention "FARIDABAD" for 30% OFF first booking).',
'Urgent slots: Same-day service available if booked before 10 AM (₹200 urgency fee applies).',

            
          ],
        },
      {
          question: "What areas do you cover?",
          text: ['We serve all sectors (Old Faridabad: Sector 16, 28, NIT; New Faridabad: Sectors 75-89, Neharpar, Ballabgarh). WhatsApp your exact location (e.g., "Near Crown Interiorz Mall") for confirmation.'],
          points: [],
        },
      {
          question: "Why choose home grooming over salons near Surajkund Road?",
          text: [""],
          points: [

"Zero traffic stress: Avoid NIT/Bypass Road jams.",
"Custom care: 1-on-1 attention (unlike crowded salons).",
"Local perks: Dust-proof baths for Aravalli hikers, neem rinses for monsoon ticks.",
            
          ],
        },
      {
          question: "Can you service high-rise apartments in Greater Faridabad?",
          text: ["Yes! We regularly groom pets in Sector 75-89 high-rises. Just ensure:",

"✔ Parking for our mobile van.",
"✔ Elevator access (or we’ll carry equipment upstairs).",
"✔ A small balcony/utility area for grooming.",

            
          ],
          points: [],
        },
      {
          question: "My Persian cat gets mats after Badkhal Lake walks. Help?",
          text: [

"We specialize in painless de-matting for Faridabad’s humidity:",
"✔ Detangling sprays (no pulling).",
"✔ Lion cuts (stylish and practical).",
"✔ Sanitary trims for hygiene.",
            
          ],
          points: [],
        },
      {
          question: "Do you handle large/aggressive breeds like Rottweilers?",
          text: [

"Absolutely! Our groomers are:",
"✔ Muzzle-trained (but prefer treat-based positive reinforcement).",
"✔ Experienced with farm dogs and guard breeds.",
"✔ Patient with rescues (common in NIT area colonies).",
            
          ],
          points: [],
        },
      {
          question: "What’s included in the ₹849 Basic Package?",
          text: [""],
          points: [

"Dust-proof bath (removes construction debris from Sectors 75-79).",
"Paw cleaning (for hot pavements near Crown Interiorz Mall).",
"Nail trim (safe for marble floors in apartments).",
            
          ],
        },
      {
          question: "How do you handle monsoon tick problems near Aravalli hills?",
          text: [

"Our Monsoon Defense Package (₹200 extra):",
"✔ Neem & aloe vera bath.",
"✔ Tick comb-out with magnifying lamp.",
"✔ Preventive spray (lasts 2 weeks).",
            
          ],
          points: [],
        },
      {
          question: "My society doesn’t allow pets. Any workarounds?",
          text: [
"We adapt!",
"✔ Society parking lots (we bring pop-up tents).",
"✔ Nearby parks (morning slots only).",
"✔ Office cabins (after hours, ideal for corporate pet parents).",
          ],
          points: [],
        },
      {
          question: "Do you service street dogs in NIT or Ballabgarh?",
          text: ["Yes! Special offers for:"],

          
          points: [

            "Community dogs: ₹499 basic grooming.",
            "Rescue orgs: Free nail trims.",
            "Feeders: First-aid training sessions.",

          ],
        },
      {
          question: "Can I reschedule/cancel?",
          text: [""],
          points: [
"Free rescheduling before 6 hours.",
"Monsoon policy: No charges for weather-related cancellations.",
          ],
        },
      {
          question: "Student/elderly discounts?",
          text: [""],
          points: [

"10% OFF for students (share Amity/Manav Rachna ID).",
"5% OFF for seniors (age 60+).",
            
          ],
        },
      
     ],
  };

  const locationData = {
    data: [


"Sector 1–21 (Old Faridabad)",
"Sector 37–46 (Mid-town area)",
"Sector 55–65 (New Faridabad)",
"Sector 75–89 (Greater Faridabad / Neharpar)",
"Sector 91–97 (BPTP & Omaxe area)",
"Old Faridabad",
"NIT (New Industrial Township)",
"Ballabhgarh",
"Greenfield Colony",
"Sainik Colony",
"Charmwood Village",
"Surajkund",
"Badkhal",
"Tigaon",
"Sector 14 Market",
"Sector 15A",
"Ashoka Enclave",
"BPTP Parklands",
"Omaxe Heights",
"Spring Field Colony",
"Neharpar (Greater Faridabad)",
"Mathura Road Industrial Belt",
"Faridabad-Noida-Ghaziabad (FNG) Expressway",
"Delhi-Mumbai Expressway Zone",
      
      
    ],
  };

  const schema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "FluffyTouch - At-Home Pet Grooming Faridabad",
  "image": "https://fluffytouch.in/logo.png",
  "url": "https://fluffytouch.in/pet-grooming-at-home/faridabad",
  "telephone": "+91-9658189189",
  "priceRange": "₹849 - ₹1399",
  "description": "Book expert dog and cat grooming at home in Faridabad. Serving all sectors including Neharpar, Old Faridabad, NIT, Ballabhgarh, and more. Same-day service and special packages for monsoon care.",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Faridabad",
    "addressRegion": "Haryana",
    "postalCode": "121001",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "28.4089",
    "longitude": "77.3178"
  },
  "openingHoursSpecification": [
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
      "opens": "08:00",
      "closes": "20:00"
    }
  ],
  "areaServed": [
    {
      "@type": "Place",
      "name": "Sector 1–21 (Old Faridabad)"
    },
    {
      "@type": "Place",
      "name": "Sector 22–31"
    },
    {
      "@type": "Place",
      "name": "Sector 37–46"
    },
    {
      "@type": "Place",
      "name": "Sector 55–65"
    },
    {
      "@type": "Place",
      "name": "Sector 75–89 (Greater Faridabad)"
    },
    {
      "@type": "Place",
      "name": "Sector 91–97 (BPTP & Omaxe)"
    },
    {
      "@type": "Place",
      "name": "Ballabhgarh"
    },
    {
      "@type": "Place",
      "name": "Greenfield Colony"
    },
    {
      "@type": "Place",
      "name": "Charmwood Village"
    },
    {
      "@type": "Place",
      "name": "Badkhal"
    },
    {
      "@type": "Place",
      "name": "Surajkund"
    },
    {
      "@type": "Place",
      "name": "NIT Faridabad"
    },
    {
      "@type": "Place",
      "name": "BPTP Parklands"
    },
    {
      "@type": "Place",
      "name": "Spring Field Colony"
    },
    {
      "@type": "Place",
      "name": "Mathura Road Industrial Belt"
    },
    {
      "@type": "Place",
      "name": "Delhi-Mumbai Expressway Zone"
    },
    {
      "@type": "Place",
      "name": "FNG Expressway Corridor"
    }
  ],
  "hasMap": "https://www.google.com/maps/place/Faridabad,+Haryana",
  "sameAs": [
    "https://www.facebook.com/fluffytouch.in",
    "https://www.instagram.com/fluffytouch.in",
    "https://fluffytouch.in"
  ],
  "serviceType": "Dog and Cat Grooming at Home",
  "makesOffer": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "849",
    "itemOffered": {
      "@type": "Service",
      "name": "Basic Pet Grooming",
      "description": "Bath, nail trim, ear cleaning, paw care for dogs and cats."
    }
  },
  "mainEntity": [
    {
      "@type": "Question",
      "name": "Do you serve apartments in Sector 75-89?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes! We’re equipped for high-rises with compact grooming kits and elevator-friendly setups."
      }
    },
    {
      "@type": "Question",
      "name": "Do you offer grooming for aggressive dogs like Rottweilers?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, our groomers are trained with muzzle use and positive reinforcement. We serve even farmhouses and large breeds."
      }
    },
    {
      "@type": "Question",
      "name": "How do I book emergency grooming in Faridabad?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Call before 10 AM for same-day slots. We charge a small urgency fee and provide live location updates."
      }
    },
    {
      "@type": "Question",
      "name": "Do you groom street dogs or community pets?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes! We offer discounts for feeders and NGOs and provide grooming for community animals."
      }
    }
  ]
};

  return (
    <div>
      <div className="faridabad-page">
        <Helmet>
          <title>
            Faridabad's Best At-Home Pet Grooming | 4.9★ Rated | FluffyTouch
          </title>
          <meta
            name="description"
            content="Book expert pet grooming in Faridabad at home! Same-day service for dogs & cats in Sector 28, 75, Ballabgarh & all areas. 30% OFF first booking - Call now!"
          />

           <script type="application/ld+json">{JSON.stringify(schema)}</script>
          
        </Helmet>

        {openForm ? <GroomingFormComponent setDynamicForm={setOpenForm} /> : ""}
        {offerPopup ? <PopupOffer open={setOfferPopup} /> : ""}

        <ScrollNavbar />

        <NavTop />
        <Nav />

        <LocationHeader
          heading={headerData.heading}
          text={headerData.text}
          form={setOpenForm}
          setPetGroom={setPetGroom}
        />

        <NumberIncrement />

        <ExploreGroomingService />

        <LocationGroomingPackageComponent petGroom={petGroom} setPetGroom={setPetGroom} />


        <LocationComponent location="Faridabad" data={locationData.data} />
        <MeetExpertsComponent form={setOfferPopup} />

        <HowFt />

        <LocationContentFaridabad />

        <OurLocation />

        <LocationFaqComponent data={faqData.data} />

        <Footer />
      </div>
    </div>
  );
};

export default FaridabadPage;
